<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    mediaType?: "video" | "song";
    url?: string;
    darkMode?: boolean;
    playing?: boolean;
    alt?: string;
    fixedMode?: "column" | "row";
    noLazy?: boolean;
    fetchPriority?: string;
    sizes?: string;
    restrictWidth?: number;
  }>(),
  {
    mediaType: "song",
    url: "",
    darkMode: false,
    playing: false,
    alt: "",
    fixedMode: "row",
  },
);

const icon = computed(() =>
  props.mediaType === "song" ? "fa-solid fa-music" : "fa-solid fa-film",
);
</script>

<template>
  <div
    class="album-artwork"
    :class="`${mediaType} fixed-${fixedMode}`"
  >
    <div
      class="content"
      :class="{ empty: !url }"
    >
      <FAIcon
        v-if="!url"
        :class="icon"
        class="placeholder-icon"
      />
      <Image
        v-else
        :src="url"
        :alt="alt"
        rounded
        transparent
        :sizes="sizes"
        :restrict-width="restrictWidth"
        :no-lazy="noLazy"
        :fetch-priority="fetchPriority"
        :placeholder-icon="icon"
      />
    </div>
    <Transition name="fade">
      <div
        v-if="playing"
        class="playing-overlay"
      >
        <PlayingIcon />
      </div>
    </Transition>
  </div>
</template>

<style scoped lang="postcss">
.album-artwork.video {
  @apply aspect-video h-full w-full;
}
.album-artwork.song {
  @apply aspect-square h-full w-full;
}

.content {
  @apply flex h-full w-full items-center justify-center rounded-lg bg-black/25 shadow-lg;
}
.placeholder-icon {
  @apply text-2xl text-black/50;
}
</style>
